import { call, takeEvery } from 'redux-saga/effects';
import listener from '@/layout/goldenLayoutListener';
import urls, { codeUrl, userGroupUrl } from '@/constants/urls';
import { createUsergroupActions, deleteUsergroupActions } from '../constants';

export function* closeTab({ items }) {
  const itemsUrls = items.map((item) => userGroupUrl(item));

  yield call(listener.closeTab, itemsUrls);
}

export function* navigateToNewUsergroup({ code, userGroupSourceCode, result }) {
  let previousUrl = codeUrl(urls.USER_GROUP, code);
  if (userGroupSourceCode) {
    previousUrl = `${codeUrl(urls.USER_GROUPS, userGroupSourceCode)}/usergroup/${encodeURIComponent(code)}`;
  }

  yield call(listener.navigate, {
    type: createUsergroupActions.CREATE_USERGROUP_SUCCESS,
    code: result.code,
    previousUrl,
    name: result.name,
    description: result.description,
    url: userGroupUrl(result),
  });
}

export default function* usergroupsLayout() {
  yield takeEvery(deleteUsergroupActions.DELETE_USERGROUP_SUCCESS, closeTab);
  yield takeEvery(createUsergroupActions.CREATE_USERGROUP_SUCCESS, navigateToNewUsergroup);
}
